import blocks from './blocks'
import blockEvents from './blockEvents'
import CRUD from '../masterData/genericCRUD'

const route = 'crop_census'

export default function cropCensus(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),
		blocks: blocks(instance),
		blockEvents: blockEvents(instance),

		/**
		 * @param {number} varietyId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmsAndBlockByVariety: (varietyId, config = {}) => {
			return instance.get(`farms/variety/${varietyId}`, config)
		},

		/**
		 * @param {number} varietyId
		 * @param {number} blockId,
		 * @param {string} age
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getPHBByAgeAndVariety: (varietyId, blockId, age, config = {}) => {
			const ageParam = age ? `age=${age}&` : ''

			const varietyIdParam = varietyId ? `varietyId=${varietyId}&` : ''

			const blockIdParam = blockId ? `blockId=${blockId}&` : ''

			return instance.get(
				`packhouse_blocks/age?${ageParam}${varietyIdParam}${blockIdParam}`,
				config
			)
		}
	}
}
